import styled from "styled-components";
export const ModalContainer = styled.div`
  background-color: #fff;
  border-radius: 14px;
  width: 90%;
  z-index: 99;
`;
export const ModalText = styled.div`
  text-align: center;
  color: #ffbf1d;
  font-weight: 900;
  font-size: 24px;
`;
export const ModalInput = styled.div`
  background-color: #f4f4f5;
  width: 100%;
  border-radius: 10px;
  margin: 20px 0;
  padding: 10px;
  color: #6c757d;
  display: flex;
  justify-content: flex-end;
`;
export const InputNum = styled.input`
  width: 100%;
  text-align: center;
  background: transparent;
`;
export const ConfirmBtn = styled.div`
  cursor: pointer;
  background-color: #2a2e43;
  border-radius: 10px;
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  margin-right: 20px;
  padding: 10px 0;
`;
export const CancelBtn = styled.div`
  cursor: pointer;
  background-color: #f4f4f5;
  border-radius: 10px;
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2a2e43;
  padding: 10px 0;
`;
export const BtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;
export const Picker = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
export const PickerContainer = styled.div`
  width: 10%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
`;
export const PickerTop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 14px;
  opacity: 0.5;
  height: 20%;
  font-weight: 900;
`;
export const PickerMain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 18px;
  border-bottom: 3px solid #2a2e43;
  border-top: 3px solid #2a2e43;
  padding: 5px;
  margin: 5px;
  font-weight: 900;
`;
export const PickerBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 14px;
  opacity: 0.5;
  height: 20%;
  font-weight: 900;
`;
